// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__3f_E2","switch":"ToggleSwitch_switch__1u9Ze"};